import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import config from "Constants/api_config";
import useDecodedParams from "Hooks/useDecodedParams";
import { loadDeploymentCurrent } from "Reducers/environment/deployment";

import getAccessToken from "../api/getAccessToken";
import {
  ActivityOutputEvents,
  ActivityInputEvents
} from "../utils/workerEventTypes";
import ActivitiesWorker from "../utils/workers/activities.worker?worker";

const refreshToken = async postMessage => {
  const accessToken = await getAccessToken();
  postMessage({ type: ActivityInputEvents.refreshToken, payload: accessToken });
};

const onMessage = (event, postMessage, setState) => {
  switch (event.data.type) {
    case ActivityOutputEvents.refreshToken:
      refreshToken(postMessage);
      break;
    case ActivityOutputEvents.error:
      setState({ error: event.data.payload });
      break;
    case ActivityOutputEvents.ready:
      setState(state => ({ ...state, activities: event.data.payload }));
      break;
    default:
  }
};

const useDedicatedWorker = selectedTimeframe => {
  const dispatch = useDispatch();

  const { organizationId, projectId, environmentId } = useDecodedParams();

  const [state, setState] = useState({ range: [] });
  const [activitiesWorker, setActivitiesWorker] = useState();

  useEffect(() => {
    const _activitiesWorker = new ActivitiesWorker();
    const activitiesWorkerPostMessage =
      _activitiesWorker.postMessage.bind(_activitiesWorker);

    getAccessToken().then(accessToken => {
      _activitiesWorker.onmessage = event =>
        onMessage(event, activitiesWorkerPostMessage, setState);

      _activitiesWorker.postMessage({
        type: ActivityInputEvents.init,
        payload: {
          projectId,
          environmentId,
          apiURL: config.api_url,
          accessToken
        }
      });

      setActivitiesWorker(_activitiesWorker);
    });

    dispatch(
      loadDeploymentCurrent({ organizationId, projectId, environmentId })
    );

    return () => {
      _activitiesWorker.postMessage({ type: ActivityInputEvents.stopPolling });
      _activitiesWorker.terminate();
    };
  }, []);

  useEffect(() => {
    if (!activitiesWorker) {
      return;
    }

    activitiesWorker.postMessage({ type: ActivityInputEvents.stopPolling });

    if (selectedTimeframe.range) {
      activitiesWorker.postMessage({
        // TODO DON'T WATCH RANGE WHEN EXTENDED TIME RANGE IS ENABLED ELSE METRICS
        // WILL NOT POLL. REWORK THIS PART TO USE ANOTHER MECHANISM MAYBE A BOOLEAN FROM RANGE PICKER
        // OR ANOTHER SOLUTION FOR WHEN RANGE IT IS NOT PREDEFINED RANGE AND THE END/TO DATE IS Date.now()
        // #EXTENDED_RANGE
        type: ActivityInputEvents.startPolling,
        payload: {
          range: selectedTimeframe.range
        }
      });
    } else {
      activitiesWorker.postMessage({
        type: ActivityInputEvents.request,
        payload: {
          from: selectedTimeframe.from,
          to: selectedTimeframe.to
        }
      });
    }
  }, [activitiesWorker, selectedTimeframe]);

  if (!state || !state?.activities) return undefined;

  return state?.activities;
};

export default useDedicatedWorker;
